import createIcon from '../../createIcon';

/**
 * @component @name NotificationsPaused
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMjEuNzVDMTMuMSAyMS43NSAxNCAyMC44NSAxNCAxOS43NUgxMEMxMCAyMC44NSAxMC44OSAyMS43NSAxMiAyMS43NVpNMTggMTUuNzVWMTAuNzVDMTggNy42OCAxNi4zNiA1LjExIDEzLjUgNC40M1YzLjc1QzEzLjUgMi45MiAxMi44MyAyLjI1IDEyIDIuMjVDMTEuMTcgMi4yNSAxMC41IDIuOTIgMTAuNSAzLjc1VjQuNDNDNy42MyA1LjExIDYgNy42OCA2IDEwLjc1VjE1Ljc1TDQgMTcuNzVWMTguNzVIMjBWMTcuNzVMMTggMTUuNzVaTTE0LjUgOS41NUwxMS43IDEyLjk1SDE0LjVWMTQuNzVIOS41VjEyLjk1TDEyLjMgOS41NUg5LjVWNy43NUgxNC41VjkuNTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NotificationsPaused = createIcon('NotificationsPaused', [
  [
    'path',
    {
      d: 'M12 21.75C13.1 21.75 14 20.85 14 19.75H10C10 20.85 10.89 21.75 12 21.75ZM18 15.75V10.75C18 7.68 16.36 5.11 13.5 4.43V3.75C13.5 2.92 12.83 2.25 12 2.25C11.17 2.25 10.5 2.92 10.5 3.75V4.43C7.63 5.11 6 7.68 6 10.75V15.75L4 17.75V18.75H20V17.75L18 15.75ZM14.5 9.55L11.7 12.95H14.5V14.75H9.5V12.95L12.3 9.55H9.5V7.75H14.5V9.55Z',
      key: 'nnxfos',
    },
  ],
]);

export default NotificationsPaused;
